import Vue from "vue";
import Vuex from "vuex";
import menu from './modules/menu' //引入菜单模块
import permission from './modules/permission'
import getters from './getters'
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    menu,
    permission
  },
  getters
});